import { processResponse } from '~/site/behaviors/remote/process_response'
import { getIntentIdAndType } from '~/site/pages/cart/payment/stripe'

let billingContainer

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector('input[name="purchase[payment_method_id]"]:checked')
    ?.dispatchEvent(new Event('change', { bubbles: true }))

  billingContainer = document.querySelector('#account-signup-billing')

  if (!billingContainer) return

  const countryField = billingContainer.querySelector('#purchase_country_code')
  const postalField = billingContainer.querySelector('#purchase_postal_code')
  const form = countryField.closest('form')
  const onAddressChange = (e) => {
    const formData = new FormData(form)
    formData.delete('_method')

    // We need this to update the intent amount server-side because country change might change taxes which might change amounts
    const { intentId, intentType } = getIntentIdAndType()
    formData.append('intent_id', intentId)
    formData.append('intent_type', intentType)

    fetch(form.dataset.countryCodeChangedUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(formData),
    })
      .then((r) => r.json())
      .then((json) => processResponse(json))
  }
  countryField.addEventListener('change', onAddressChange)
  postalField.addEventListener('change', onAddressChange)
})
